const Backbone = require('backbone');
const SocialEmailModel = require('app/models/store/client/social_email');
const formValidator = require('formValidator');
require('bootstrap');
require('vendor/jquery.tooltipster');
var _showError = function(errors) {
	window.BCOM.notifications.render(errors || 'We apologize but there was an error sending your email. Please try again.', 'warning');
};

var SocialEmailModalView = Backbone.View.extend({
	el: '.js-modal-social-email',
	events: {
		'click .js-send-email-button': 'sendEmail'
	},
	initialize: function() {
		this.validator = formValidator.init({
			el: '.js-email-form'
		});
	},
	sendEmail: function(e) {
		e.preventDefault();
		var self = this,
			socialEmail = new SocialEmailModel(),
			$emailForm = this.$('.js-email-form'),
			$button = self.$('.js-send-email-button'),
			model = this.serializeForm($emailForm);

		if (!$emailForm.valid()) {
			return;
		}

		$button.button('loading');

		model.productUniqueId = window.dataLayer.finishes[0].uniqueId;

		socialEmail.save(model, {
			success: function(model, response) {
				if (response.status === 1) {
					self.hideModal();
					window.BCOM.notifications.render('Email sent!', 'success');
					self.$('.js-email-form')[0].reset();
				} else {
					_showError.call(self, response.errors);
				}
				$button.button('reset');
			},
			error: function() {
				$button.button('reset');
				_showError.call(self);
			}
		});
	},
	hideModal: function() {
		this.$el.modal('hide');
	}
});

module.exports = SocialEmailModalView;
